import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import Keycloak from "keycloak-js";

export const authGuard: CanActivateFn = async (route, state) => {
  const keycloak = inject(Keycloak);

  if (!keycloak.authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
    return false;
  }

  return true;
};
